/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useRef } from 'react';
import {
  FlatList,
  View,
  StyleSheet,
  UIManager,
  Dimensions,
} from 'react-native';
import Colors from '@global/colors';
import { isNative, isAndroid } from '@global/screens';

import SliderIndicator from '@components/slider/SliderIndicator';

const dimension = Dimensions.get('window');

const Slider = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const dataSlider = props.data && props.data.length ? props.data : []; // data for showing the slider
  const width = props.width ? props.width : dimension.width; // width of slider
  const maxHeight = props.maxHeight ? props.maxHeight : false; // max height of slider
  const renderItem = props.renderItem ? props.renderItem : null; // how we are rendering component for slider item
  const separatorWidth = props.separatorWidth ? props.separatorWidth : 0; // separator with of slider
  const indicator = props.indicator ? props.indicator : true; // show/hide indicator/pagination slider
  const indicatorStyle = props.indicatorStyle ? props.indicatorStyle : {}; // indicator/pagination styles
  const indicatorContainerStyle = props.indicatorContainerStyle
    ? props.indicatorContainerStyle
    : {}; // indication/pagination container style
  const indicatorActiveColor = props.indicatorActiveColor
    ? props.indicatorActiveColor
    : Colors.blue2; // indication/pagination active color
  const indicatorInActiveColor = props.indicatorInActiveColor
    ? props.indicatorInActiveColor
    : Colors.grey0; // indication/pagination not active color
  const indicatorActiveWidth = props.indicatorActiveWidth
    ? props.indicatorActiveWidth
    : 6; // width indication/pagination
  const contentContainerStyle = props.contentContainerStyle
    ? props.contentContainerStyle
    : {}; // container content style

  const slider = useRef();
  const totalItemWidth = width + separatorWidth;

  if (isAndroid) {
    UIManager.setLayoutAnimationEnabledExperimental(true);
  }

  // cek current active slider
  const onViewRef = useRef(({ viewableItems }) => {
    if (viewableItems.length > 0) {
      const cIndex = viewableItems[0].index;
      setCurrentIndex(cIndex);
    }
  });
  const viewConfigRef = useRef({ viewAreaCoveragePercentThreshold: 50 });

  // set new current active slider
  const setNewCurrentIndex = (index) => {
    setCurrentIndex(index);
    try {
      slider.current.scrollToIndex({ animated: true, index: index });
    } catch (error) {}
  };

  // validate the item has url
  const checkImage = (url) => {
    if (url) {
      return url;
    }
    return require('@assets/img/default/image-default.png');
  };

  return (
    <View>
      {/* Item Container */}
      {!isNative ? (
        <View
          style={[
            contentContainerStyle,
            { width: totalItemWidth, maxHeight: maxHeight },
          ]}>
          {dataSlider && dataSlider.length
            ? renderItem({
                item: checkImage(dataSlider[currentIndex]),
                index: currentIndex,
              })
            : false}
        </View>
      ) : (
        <FlatList
          ref={slider}
          horizontal
          pagingEnabled={true}
          snapToInterval={totalItemWidth}
          decelerationRate="fast"
          bounces={false}
          contentContainerStyle={contentContainerStyle}
          maxHeight={maxHeight}
          data={dataSlider}
          showsHorizontalScrollIndicator={false}
          renderItem={({ item, index }) =>
            renderItem({ item: checkImage(item), index: index })
          }
          keyExtractor={(item, index) => item.toString() + index}
          onViewableItemsChanged={onViewRef.current}
          viewabilityConfig={viewConfigRef.current}
          getItemLayout={(data, index) => ({
            length: totalItemWidth,
            offset: totalItemWidth * index,
            index,
          })}
          windowSize={1}
          initialNumToRender={1}
          maxToRenderPerBatch={1}
          removeClippedSubviews={true}
        />
      )}
      {/* Indicator Container */}
      {indicator ? (
        <SliderIndicator
          itemCount={dataSlider.length}
          currentIndex={currentIndex % dataSlider.length}
          indicatorStyle={indicatorStyle}
          indicatorContainerStyle={[
            styles.indicatorContainerStyle,
            indicatorContainerStyle,
          ]}
          indicatorActiveColor={indicatorActiveColor}
          indicatorInActiveColor={indicatorInActiveColor}
          indicatorActiveWidth={indicatorActiveWidth}
          style={{ ...styles.indicator, ...indicatorStyle }}
          onChangeIndex={(index) => setNewCurrentIndex(index)}
        />
      ) : (
        false
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  indicatorContainerStyle: {
    marginTop: 10,
  },
});

export default Slider;
